import React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

const IncidentTypeLocation = ({ formValues, handleChange }) => (
  <Grid
    item
    xs={12}
    md={6}
    lg={3}
    display="flex"
    gap={2}
    flexDirection="column"
  >
    <Box display="flex">
      <FormControl fullWidth>
        <InputLabel>Incident Type</InputLabel>
        <Select
          value={formValues?.incident?.incidentType ?? ''}
          disabled={
            !!formValues?.incident?.createdFromTreatmentLocation ||
            !!formValues?.incident?.cadIncident
          }
          onChange={(e) => {
            handleChange({
              moduleName: 'incident',
              field: 'incidentType',
              value: e.target.value,
            })
            // "Occurred at the event?" only makes sense for Event incidents
            if (
              e.target.value !== 'Event' &&
              formValues?.incident?.injuryOccurredAtEvent
            )
              handleChange({
                moduleName: 'incident',
                field: 'injuryOccurredAtEvent',
                value: undefined,
              })
          }}
          name="type"
          label="Incident Type"
        >
          {[
            'Event',
            '999',
            'Patient Transfer',
            'Off Duty or Travelling',
            'Other',
          ].map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  </Grid>
)

export default IncidentTypeLocation
